import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {QuillEditorComponent, Range} from 'ngx-quill';
import {
  AudioTranscriptionComponent, TranscriptionConfig
} from '../../../modules/common/audio/transcription/api/component/audio-transcription/audio-transcription.component';
import Quill from "quill";
import {
  AudioTranscriptionConfig, AudioTranscriptionV2Component, AudioTranscriptionV2ComponentTranscription
} from "../../../modules/common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.scss'],
})
export class RichTextEditorComponent implements OnInit {

  configuration = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
        [{'font': []}],
        ['blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
        [{'align': []}],
      ['link'],
      ['clean'],
    ],
  };

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() ngModel: string;
  @Input() display: 'compact' | 'normal' = 'compact';
  @Input() focus = false;
  // Deprecated: use audioTranscriptionConfig instead
  // @Input() audioTranscription: TranscriptionConfig;
  @Input() audioTranscriptionConfig: AudioTranscriptionConfig;

  @Output() contentChangeEvent = new EventEmitter<string>();
  @Output() transcriptionImprovementEndedEvent = new EventEmitter<void>();
  @Output() transcriptionStartedEvent = new EventEmitter<void>();
  @Output() transcriptionEndedEvent = new EventEmitter<AudioTranscriptionV2ComponentTranscription>();


  @ViewChild('editor') editor: QuillEditorComponent;
  // @ViewChild('audioTranscriptionComponent') audioTranscriptionComponent: AudioTranscriptionComponent;
  @ViewChild('audioTranscriptionComponentV2') audioTranscriptionV2Component: AudioTranscriptionV2Component;

  ignoreTranscriptionMessage = false;
  transcriptionIndex = -1;
  transcriptionText = '';
  constructor() {

  }

  ngOnInit() {
  }

  onEditorCreated(quill: any) {

    // Récupère le HTML actuel (depuis le formControl) et le convertit en Delta
    const html = this.parentFormGroup?.get(this.parentFormControlName)?.value as string;
    if (html) {
      const delta = quill.clipboard.convert(html);
      quill.setContents(delta);
      quill.setSelection(0, 0); // remet le curseur au début (facultatif)

      // IMPORTANT : garde la valeur du formControl en HTML (pour l’email)
      // et assure la synchro si nécessaire :
      const currentHtml = quill.root.innerHTML;
      if (currentHtml !== html) {
        // évite une boucle d’événements en passant { emitEvent: false } si utile
        this.parentFormGroup?.get(this.parentFormControlName)?.setValue(currentHtml, { emitEvent: false });
      }
    }
  }


  get selectedText(): string {
    const selection = this.selection;
    if (selection) {
      return this.editor.quillEditor.getText(selection.index, selection.length);
    } else {
      return undefined;
    }
  }

  get html(): string {
    return this.editor.quillEditor.root.innerHTML;
  }

  get selectedHtml(): string {
    const selection = this.selection;
    if (selection) {
      const delta = this.editor.quillEditor.getContents(selection.index, selection.length);
      const tempQuill = new Quill(document.createElement('div'));
      tempQuill.setContents(delta);
      return tempQuill.root.innerHTML;
    } else {
      return undefined;
    }
  }

  onContentChange(content: string) {
    // console.log('content changed ' + this.editor.quillEditor.getSelection()?.index);
    this.contentChangeEvent?.emit(content);
  }

  get selection(): Range {
    return this.editor.quillEditor.getSelection();
  }

  insertString(str: string) {
    // console.log(['selection', this.selection?.index]);
    const selection = this.selection;
    if (selection) {
        this.editor.quillEditor.deleteText(selection.index, selection.length);
    }
    const index = selection ? selection.index : 0;
    this.editor.quillEditor.clipboard.dangerouslyPasteHTML(index, str);
    this.control.setValue(this.editor.quillEditor.root.innerHTML);
  }

  clear() {
    this.editor.quillEditor.setText('');
    this.control.setValue(undefined);
  }



  transcriptionStarted() {
    this.ignoreTranscriptionMessage = false;
    // Capturer la sélection actuelle
    const selection = this.editor.quillEditor.getSelection(true);
    if (selection) {
      this.transcriptionIndex = selection.index;
    } else {
      // Si aucune sélection, utiliser la longueur du texte comme index
      this.transcriptionIndex = this.editor.quillEditor.getLength();
    }
    this.transcriptionStartedEvent.emit();
  }

  transcriptionEnded(event: AudioTranscriptionV2ComponentTranscription, emitEvent = true) {
    console.log('transcriptionEnded', event);
    if (event?.transcription) {
      this.parentFormGroup.get(this.parentFormControlName).setValue(event?.transcription);
    }
    if (emitEvent) {
      this.transcriptionEndedEvent?.emit(event);
    }
  }
  transcriptionImprovementEnded(event: AudioTranscriptionV2ComponentTranscription) {
    console.log('transcriptionImprovementEnded', event);
    this.transcriptionEnded(event, false);
    this.transcriptionImprovementEndedEvent.emit();
  }

  get control(): UntypedFormControl {
    return this.parentFormGroup.get(this.parentFormControlName) as UntypedFormControl;
  }

  stopTranscription() {
    // this.audioTranscriptionComponent?.stopTranscription();
    this.audioTranscriptionV2Component?.stopTranscription();
    this.ignoreTranscriptionMessage = true;
  }

  setFocus() {
    console.log('set focus ' + this.focus);
    if (this.focus) {
      this.editor.quillEditor.focus();
    }
  }
}
